import React, { Fragment } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import HeaderCard from '../../Common/HeaderCard';
import { TREE_VIEW } from '../../../Data/Bonus-ui/Data';
import TreeView, { flattenTree } from "react-accessible-treeview";
import { ArrowIcon, CheckBoxIcon } from './BasicTree';


const DisabledTree = () => {
    const disableTreeData = flattenTree(TREE_VIEW);
  return (
    <Fragment>
      <Col sm="6">
        <Card>
          <HeaderCard title="Checkbox Tree" />
          <CardBody>
            <TreeView
              data={disableTreeData}
              aria-label="Checkbox tree"
              multiSelect
              propagateSelect
              propagateSelectUpwards
              defaultDisabledIds={[2, 3, 4, 5]}
              togglableSelect
              expandedIds={[1, 2, 6, 10]}
              nodeRenderer={({ element, isBranch, isExpanded, isSelected, isDisabled, isHalfSelected, getNodeProps, level, handleSelect, handleExpand }) => {
                return (
                  <div {...getNodeProps({ onClick: handleExpand })} style={{ marginLeft: 40 * (level - 1), opacity: isDisabled ? 0.5 : 1, marginTop: 5 }}>
                    {isBranch && <ArrowIcon isOpen={isExpanded} />}
                    <CheckBoxIcon
                      className="checkbox-icon "
                      onClick={(e) => {
                        handleSelect(e);
                        e.stopPropagation();
                      }}
                      variant={isHalfSelected ? "some" : isSelected ? "all" : "none"}
                    />
                    <span className="name">{element.name}</span>
                  </div>
                );
              }}
            />
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default DisabledTree;
